export default {
    getHeaderFieldsEprofileImplantatum: state => state.headerFieldsEprofileImplantatum,
    getFormActionsEprofileImplantatum: state => state.formActionsEprofileImplantatum,
    getActionsEprofileImplantatum: state => state.actionsEprofileImplantatum,
    getRowActionsEprofileImplantatum: state => state.rowActionsEprofileImplantatum,
    getSearchFields: state => state.searchFields,
    isFormOpenEprofileImplantatum: state => state.formIsOpen,
    isGridOpenEprofileImplantatum: state => state.gridIsOpen
}
